export default "__VITE_ASSET__D88NaTjB__"